<template>
  <div
    class="relative hidden bg-slate-50 bg-gradient-to-t from-zuno-turquoise/10 to-transparent lg:block"
  >
    <div
      class="mx-auto max-w-3xl px-8 py-10 md:py-10 lg:max-w-6xl lg:py-10 lg:pb-16"
    >
      <div class="relative">
        <div class="text-center">
          <h2
            class="relative text-2xl font-semibold leading-tight tracking-tight text-[#20484F] md:text-4xl lg:text-[2.7em] lg:leading-tight"
          >
            Versatile Solution for Any Industry
          </h2>
          <div class="mx-auto mb-8 max-w-lg md:mb-10 lg:mb-14 lg:max-w-lg">
            <p class="mt-6 text-base text-gray-500 md:text-base lg:text-base">
              Whether you are in Oil and Gas or Manufacturing, Veridis provides
              innovative solutions to ensure you reach your Net-Zero goals.
            </p>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-2 gap-0 lg:grid-cols-4 lg:gap-4">
        <div
          class="mb-4 rounded-3xl bg-white px-3 py-3 shadow-sm lg:mb-0 lg:px-10 lg:py-10"
        >
          <div>
            <div class="mb-3 lg:mb-3">
              <IndustryDuotone class="text-lg" />
            </div>
            <div class="text-lg font-light text-gray-900 lg:text-lg">
              Manufacturing
            </div>
            <p class="mt-6 text-sm text-gray-700 md:text-base lg:text-sm">
              Track and report your carbon footprint across all scopes,
              operations and assets
            </p>
          </div>
        </div>

        <div
          class="mb-4 rounded-3xl bg-white px-3 py-3 shadow-sm lg:mb-0 lg:px-10 lg:py-10"
        >
          <div>
            <div class="mb-3 lg:mb-3">
              <HouseDuotone class="text-lg" />
            </div>
            <div class="text-lg font-light text-gray-900 lg:text-lg">
              Real Estate
            </div>
            <p class="mt-6 text-sm text-gray-700 md:text-base lg:text-sm">
              Meet your sustainability goals by leveraging granular activity
              data across your building systems
            </p>
          </div>
        </div>

        <div
          class="mb-4 rounded-3xl bg-white px-3 py-3 shadow-sm lg:mb-0 lg:px-10 lg:py-10"
        >
          <div>
            <div class="mb-3 lg:mb-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="text-xl"
                viewBox="0 0 576 512"
                height="20"
                width="20"
              >
                <path
                  id="mainIconPathAttribute"
                  d="M569.8 215.8C581.2 258.5 555.9 302.4 513.2 313.8L497.7 317.9C480.7 322.5 463.1 312.4 458.5 295.3L433.3 201.3L95.1 288.8V448H137.3L190.4 296.3L264.1 276.1L238.7 352H305.3L277.9 273.6L340 257.5L406.7 448H544C561.7 448 576 462.3 576 480C576 497.7 561.7 512 544 512H32C14.33 512 0 497.7 0 480C0 462.3 14.33 448 32 448H48V184C48 170.7 58.75 160 72 160C85.25 160 96 170.7 96 184V222.6L228.2 188.4L241.8 149.4C246.3 136.6 258.4 128 272 128C285.6 128 297.7 136.6 302.2 149.4L308.5 167.5L416.8 139.5L392.3 48.04C387.7 30.97 397.8 13.42 414.9 8.848L430.4 4.707C473-6.729 516.9 18.6 528.3 61.28L569.8 215.8zM205.1 448H338.9L327.7 416H216.3L205.1 448z"
                  stroke-width="0"
                  stroke="#ff0000"
                  fill="#000000"
                  filter="url(#shadow)"
                />
                <filter id="shadow">
                  <feDropShadow
                    id="shadowValue"
                    stdDeviation=".5"
                    dx="0"
                    dy="0"
                    flood-color="black"
                  />
                </filter>
                <filter id="shadow">
                  <feDropShadow
                    id="shadowValue"
                    stdDeviation=".5"
                    dx="0"
                    dy="0"
                    flood-color="black"
                  />
                </filter>
              </svg>
            </div>
            <div class="text-lg font-light text-gray-900 lg:text-lg">
              Oil and Gas
            </div>
            <p class="mt-6 text-sm text-gray-700 md:text-base lg:text-sm">
              Achieve greater accuracy and transparency of data across all
              emission scopes
            </p>
          </div>
        </div>

        <div
          class="mb-4 rounded-3xl bg-white px-3 py-3 shadow-sm lg:mb-0 lg:px-10 lg:py-10"
        >
          <div>
            <div class="mb-3 lg:mb-3">
              <BoltDuotone class="text-lg" />
            </div>
            <div class="text-lg font-light text-gray-900 lg:text-lg">
              Energy Transition
            </div>
            <p class="mt-6 text-sm text-gray-700 md:text-base lg:text-sm">
              Reach your sustainability goals with actionable insights at every
              step of your energy transition journey
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HowItWorkSection',
}
</script>
